/* eslint-disable no-undef */

import React from 'react';
import './ListViewRightPart.sass';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import OrderForm from '../../../containers/OrderFormWrapper/OrderFormWrapper';
import SideSteps from '../../Steps/SideSteps';
import VirtualTourForm from '../../VirtualTourForm';
import * as media from '../../../constants/mediaQueries';

const ListViewRightPart = (props) => {
  const { urls } = props;

  return (
    <div className="row rightPart">
      <div className="col-sm-6 col-md-12">
        <SideSteps />
      </div>
      {(!window.location.pathname.includes(urls.virtual)) && (
        <div className="col-sm-6 col-md-12">
          <VirtualTourForm urls={urls} />
        </div>
      )}
      <MediaQuery minWidth={media.SCREEN_MD_MIN}>
        <div className="col-sm-6 col-md-12 sticky-column">
          <OrderForm />
        </div>
      </MediaQuery>
    </div>
  );
};

ListViewRightPart.propTypes = {
  urls: PropTypes.oneOfType([PropTypes.object]),
};

ListViewRightPart.defaultProps = {
  urls: {},
};

export default ListViewRightPart;
